const PartnerDesc = ({ data, id }) => {
    const bgGradient = "linear-gradient(90deg, rgb(0, 222, 161) 0%, rgb(0, 222, 161) 10%, #3fb2dd 30%, hsl(220, 97.3%, 55.9%) 100%)";
    return (
        <section id={id} className="py-12">
            <div
                className="w-full"
                style={{ background: bgGradient }}
            >
                {/* 内部容器，宽度和 Navbar 对齐 */}
                <div className="mx-auto w-full px-4 sm:px-6 lg:w-[70%] lg:max-w-[1440px]">
                    <div className="py-20">
                        <h3 className="text-white text-4xl font-semibold sm:text-5xl">
                            {data.descTitle}
                        </h3>
                        <p className="text-white text-xl font-semibold sm:text-2xl mt-2 py-4">
                            {data.desc}
                        </p>
                    </div>
                </div>
            </div>

            {/* 下面的内容保持和Navbar宽度一致 */}
            <div className="mx-auto lg:w-[70%] lg:max-w-[1440px] mt-10">
                <div className='space-y-6 justify-center gap-8 sm:grid sm:grid-cols-2 sm:space-y-0 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4'>
                    {
                        data.items.map((item, idx) => (
                            <a href={item.link} target={item.name ? item.name : '_self'} key={idx}>
                                <div
                                    className="shadow-xl flex items-center p-6 rounded-xl border-2 space-x-6 w-full h-full min-h-[200px]"
                                    style={{ height: '100%' }}
                                >
                                    {/* 左边图片 */}
                                    <img
                                        alt=""
                                        className="h-[70px] w-[70px] rounded-full bg-gray-200 p-1 flex-shrink-0"
                                        src={item.imgRound}
                                    />

                                    {/* 右边文字 */}
                                    <div className="flex flex-col">
                                        <span className="text-gray-800 text-2xl font-bold">
                                            {item.name}
                                        </span>
                                        <p className="text-blue-500 text-base mt-2 max-w-sm">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            </a>


                        ))
                    }
                </div>
            </div>
        </section>
    );
};

export default PartnerDesc;
